module.exports = __webpack_public_path__ + "img/nifs_login.3bdb6d42.jpg";